angular.module("vgresiduos").controller("createDriverPopupCtrl", [
	"$scope",
	"$rootScope",
	"dialogService",
	"supplierCode",
	function ($scope, $rootScope, dialogService, supplierCode) {
		"use strict";

		$scope.labels = $rootScope.labels;
		$scope.supplierCode = supplierCode;
		$scope.queries = [{ label: "popupForm", value: true }];

		$scope.$on(Vgr.constants.evtIframeOnSuccessCreateDriver, function (event, data) {
			dialogService.confirm(data);
		});

		$scope.$on(Vgr.constants.evtIframeOnCancelCreateDriver, function (event, data) {
			dialogService.hide($scope.dialog);
		});
	}
]);
